import React from "react";
import { CheckCircle2, AlertCircle, AlertTriangle } from "lucide-react";

const VARIANTS = {
  green: {
    label: "Ready",
    sublabel: "Greenlight",
    icon: CheckCircle2,
    color: "#4ADE80",
    bg: "rgba(74, 222, 128,0.10)",
    border: "rgba(74, 222, 128,0.35)",
  },
  yellow: {
    label: "Refine",
    sublabel: "Yellowlight",
    icon: AlertCircle,
    color: "#EAB308",
    bg: "rgba(234,179,8,0.10)",
    border: "rgba(234,179,8,0.35)",
  },
  red: {
    label: "Rethink",
    sublabel: "Redlight",
    icon: AlertTriangle,
    color: "#EF4444",
    bg: "rgba(239,68,68,0.10)",
    border: "rgba(239,68,68,0.35)",
  },
};

// Vertical "status card" matching the Lightbulb tracker's "Ready" callout:
// huge band word in color, small uppercase sublabel underneath, big check on the right.
export default function BandPill({ band = "yellow" }) {
  const v = VARIANTS[band] || VARIANTS.yellow;
  const Icon = v.icon;
  return (
    <div
      data-testid={`band-pill-${band}`}
      className="w-full flex items-center justify-between gap-4 px-5 py-4 sm:gap-6 sm:px-7 sm:py-6 rounded-3xl"
      style={{ background: v.bg, border: `1px solid ${v.border}` }}
    >
      <div className="flex-1 min-w-0">
        <div
          className="font-black leading-none tracking-tight text-3xl sm:text-5xl"
          style={{ color: v.color }}
        >
          {v.label}
        </div>
        <div
          className="mt-2 text-[10px] sm:text-xs font-bold uppercase tracking-[0.18em]"
          style={{ color: v.color, opacity: 0.85 }}
        >
          {v.sublabel}
        </div>
      </div>
      <div
        className="flex-shrink-0 w-11 h-11 sm:w-16 sm:h-16 rounded-full flex items-center justify-center"
        style={{ border: `2px solid ${v.color}`, background: "rgba(0,0,0,0.2)" }}
      >
        <Icon size={22} strokeWidth={2.4} style={{ color: v.color }} />
      </div>
    </div>
  );
}
